import React, { useEffect, useState } from 'react';
import {
  useTable,
  useSortBy,
  useGlobalFilter,
  usePagination,
  TableInstance,
} from 'react-table';
import { Navigate, useNavigate } from 'react-router-dom';

// Chakra imports
import {
  Flex,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Input,
  Box,
  Button,
  Tooltip,
  SimpleGrid,
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import { SearchIcon } from '@chakra-ui/icons';
import {
  IconButton,
  InputGroup,
  InputLeftElement,
  useColorModeValue,
} from '@chakra-ui/react';
import SelectField from 'components/fields/SelectField';
import {
  getCompanyNames,
  getCreatorNames,
  getAllCohorts,
} from 'utils/cohorts/cohorts';
import { HashLoader } from 'react-spinners';

interface IndustryData {
  label: any;
  sNo: number;
  chId: any;
  ctName: any;
  cpCompanyName: any;
  CohortName: string;
  NoGames: any;
  NoLearners: any;
  Nooflearners: number;
  action: JSX.Element;
  value: any;
}

type RowObj = {
  sNo: number;
  chId: any;
  ctName: any;
  cpCompanyName: any;
  CohortName: string;
  NoGames: any;
  NoLearners: any;
  action: JSX.Element;
  value: any;
};

interface ColumnObj {
  Header: number | string;
  accessor: keyof RowObj;
}

interface cohortsDataTableProps {
  data: RowObj[];
  setApiData: React.Dispatch<React.SetStateAction<IndustryData[]>>;
  setCompany: any;
}

interface OptionTypecon {
  value: string;
  label: string;
  CompanyId: string;
}
interface OptionType {
  value: string;
  label: string;
}

type DataCol = TableInstance<RowObj>;

const CohortsTable: React.FC<cohortsDataTableProps> = ({
  data,
  setApiData,
  setCompany,
}) => {
  const storage = JSON.parse(localStorage.getItem('user'));
  const UserRole = storage.data.role;
  const UserId = storage.data.id;

  const [localPageIndex, setLocalPageIndex] = useState(0);
  const [localPageSize, setLocalPageSize] = useState(10);
  const [lastPage, setLastPage] = useState<any>();
  const [creators, setCreators] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [getId, setGetId] = useState<any>();

  const [selected, setSelected] = useState({
    companyId: '',
    creatorId: '',
  });
  const [loadingdata, setLoadingdata] = useState(false);
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate('creation');
  };

  const columns: ColumnObj[] = React.useMemo(() => {
    let userRoleColumns: ColumnObj[];
    if (UserRole === 'Admin') {
      userRoleColumns = [
        { Header: 'S.No', accessor: 'sNo' },
        { Header: 'Creator Name', accessor: 'ctName' },
        { Header: 'Company Name', accessor: 'cpCompanyName' },
        { Header: 'Cohort Name', accessor: 'CohortName' },
        { Header: 'No Games', accessor: 'NoGames' },
        { Header: 'No Learners', accessor: 'NoLearners' },
        { Header: 'Action', accessor: 'action' },
      ];
    } else if (UserRole === 'Creator') {
      userRoleColumns = [
        { Header: 'S.No', accessor: 'sNo' },
        { Header: 'Creator Name', accessor: 'ctName' },
        { Header: 'Cohort Name', accessor: 'CohortName' },
        { Header: 'No Games', accessor: 'NoGames' },
        { Header: 'No Learners', accessor: 'NoLearners' },
        { Header: 'Action', accessor: 'action' },
      ];
    }
    return userRoleColumns;
  }, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    state: { pageIndex, pageSize, globalFilter },
    setGlobalFilter,
    gotoPage,
    setPageSize,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
  }: DataCol = useTable<RowObj>(
    {
      columns,
      data: data,

      initialState: { pageIndex: localPageIndex, pageSize: localPageSize },
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
  );

  // Lokie Add
  useEffect(() => {
    const fetchData = async () => {
      try {
        const company = await getCompanyNames();
        if (company?.status == 'Success') {
          setCompanyOptions(company?.data);
          setCompany(company?.data);
        } else {
          return console.log('getCompanyNames Error :', company?.message);
        }
        const creator = await getCreatorNames();
        if (creator?.status !== 'Success') {
          return console.log('getCreatorNames Error:', creator?.message);
        } else {
          setCreators(creator.data);
        }
      } catch (error) {
        console.error('An error occurred while fetching data:', error);
      }
    };

    fetchData();
  }, []);

  const handleCompanyChange = (selectedOption: OptionType | null) => {
    setSelected({
      ...selected,
      companyId: selectedOption.value,
      creatorId: '',
    });
    setGetId(selectedOption.value);
  };
  const handleCreatorIdChange = (selectedOption: OptionTypecon | null) => {
    if (selectedOption) {
      setSelected({
        ...selected,
        creatorId: selectedOption.value,
        companyId: selectedOption.CompanyId,
      });
    } else {
      // Handle the case where selectedOption is null if needed
    }
  };

  // Lokie End
  useEffect(() => {
    const fetchDatas = async () => {
      //  const data = companyOptions ? companyOptions:'';
      const data = JSON.stringify(selected);
      try {
        const creator = await getCreatorNames(data);

        if (creator?.status === 'Success') {
          setCreators(creator.data);
        } else {
          return console.log('getPlanNames Error:', creator?.message);
        }
      } catch (error) {
        console.error('An error occurred while fetching data:', error);
      }
    };

    fetchDatas();
  }, [getId]);
  const handleClick = async () => {
    setLoadingdata(true);

    const combinedData = {
      selected,
      role: UserRole,
      id: UserId,
    };

    let datas = JSON.stringify(combinedData);

    try {
      const result = await getAllCohorts(datas);

      if (result?.status !== 'Success') {
        setApiData([]);
        return;
      }

      let filteredData = result?.data;

      if (selected.companyId) {
        filteredData = filteredData.filter(
          (item: any) => item.cpId === selected.companyId,
        );
      }

      if (selected.creatorId) {
        filteredData = filteredData.filter(
          (item: any) => item.ctId === selected.creatorId,
        );
      }

      setApiData(filteredData);
    } catch (error) {
      console.log('Fetch Data Error: ', error);
      setApiData([]);
    } finally {
      setLoadingdata(false);
    }
  };

  useEffect(() => {
    handleClick();
  }, [selected.companyId, selected.creatorId]);

  useEffect(() => {
    const lastPage = Math.floor(data.length / pageSize);
    setLastPage(Math.floor(data.length / pageSize));
  }, []);

  const totalPages = Math.ceil(data.length / pageSize);
  const searchIconColor = useColorModeValue('gray.700', 'white');
  let menuBg = useColorModeValue('white', 'navy.800');
  const shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
    '14px 17px 40px 4px rgba(112, 144, 176, 0.06)',
  );

  const getPageNumbers = () => {
    const pageCount = 3; // Adjust the number of visible page numbers as needed
    const currentPage = pageIndex + 1;
    const pages = [];

    if (totalPages <= pageCount) {
      // Display all pages if total pages are less than or equal to the page count
      for (let i = 0; i < totalPages; i++) {
        pages.push(i + 1);
      }
    } else {
      // Display a range of pages with three dots in between
      const start = Math.max(1, currentPage - Math.floor(pageCount / 2));
      const end = Math.min(totalPages, start + pageCount - 1);

      if (start > 1) {
        pages.push(1, '...'); // Display first page and three dots if not in the initial range
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (end < totalPages) {
        pages.push('...', totalPages); // Display three dots and last page if not in the final range
      }
    }

    return pages;
  };

  useEffect(() => {
    setLocalPageIndex(pageIndex);
  }, [pageIndex]); // Ensure to sync whenever pageIndex changes

  // Update the handleGoPage function
  const handleGoPage = (pageNumber: number) => {
    // Ensure the page number is within valid range
    if (pageNumber >= 0 && pageNumber < totalPages) {
      gotoPage(pageNumber); // Let react-table handle the page change
    }
  };

  // Update the previous and next page logic
  const handlePageChange = (action: 'previous' | 'next') => {
    if (action === 'next' && canNextPage) {
      nextPage();
    } else if (action === 'previous' && canPreviousPage) {
      previousPage();
    }
  };

  return (
    <>
      {loadingdata && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(10px)',
          }}
        >
          <HashLoader color="#3b38e0" />
        </div>
      )}
      <Card mt={'20px'} width={'100%'}>
        <SimpleGrid
          columns={{ base: 1, md: 3, lg: 3 }}
          // ml="30px"
          spacing={6}
        >
          {/* fsdfdsa */}

          {UserRole === 'Admin' ? (
            <>
              {/* Admin content goes here */}
              <SelectField
                mb="0px"
                id="ctCompanyId"
                name="companyId"
                label="Company Name"
                options={companyOptions}
                onChange={handleCompanyChange}
                value={
                  companyOptions.find(
                    (option) => option.value === selected.companyId,
                  ) || null
                }
                isDisabled={storage.data.role === 'Creator'}
                isClearable={true}
              />
              <SelectField
                mb="0px"
                id="ctCompanyId"
                name="planId"
                label="Creater Name"
                options={creators}
                onChange={handleCreatorIdChange}
                value={
                  creators.find(
                    (option) => option.value === selected.creatorId,
                  ) || null
                }
                isClearable={true}
              />
            </>
          ) : null}
        </SimpleGrid>
      </Card>

      <Flex
        justifyContent="flex-end"
        align={'center'}
        mb={'10px'}
        p={{ sm: '20px 0px', md: '20px' }}
      >
        <Flex
          w={{ sm: '100%', md: 'auto' }}
          alignItems="center"
          flexDirection={{ base: 'column', sm: 'column', md: 'row' }}
          bg={menuBg}
          flexWrap={{ base: 'wrap', md: 'nowrap' }}
          p="10px"
          borderRadius="20px"
          boxShadow={shadow}
          justifyContent={'space-between'}
        >
          <InputGroup w={{ base: '100%', sm: '100%', md: '200px' }}>
            <InputLeftElement
              children={
                <IconButton
                  aria-label="search"
                  bg="inherit"
                  borderRadius="inherit"
                  _active={{
                    bg: 'inherit',
                    transform: 'none',
                    borderColor: 'transparent',
                  }}
                  _hover={{
                    background: 'none',
                  }}
                  _focus={{
                    background: 'none',
                    boxShadow: 'none',
                  }}
                  icon={
                    <SearchIcon color={searchIconColor} w="15px" h="15px" />
                  }
                />
              }
            />

            <Input
              type="text"
              placeholder="Search..."
              value={globalFilter || ''}
              onChange={(e) => setGlobalFilter(e.target.value)}
              bg={'#f9f9f9'}
              borderRadius={'14px'}
              w={{ base: '100%', sm: '100%', xl: '300px' }}
            />
          </InputGroup>

          <Tooltip label="Create a New Cohort" hasArrow placement="right-start">
            <Button
              ml={{ sm: 0, md: 10 }}
              mt={{ sm: 5, md: 0 }}
              padding={2}
              boxShadow={'3px 4px 12px #2e292940'}
              _hover={{ bg: '#3311db', boxShadow: '3px 4px 12px #2e292975' }}
              background="#3311db"
              color="#fff"
              w={{ sm: '100%', md: 70 }}
              onClick={handleNavigate}
            >
              New
            </Button>
          </Tooltip>
        </Flex>
      </Flex>
      <Box
        overflowX={{ sm: 'scroll', xl: 'scroll' }}
        padding="2px"
        borderRadius={'13px 13px 20px 20px'}
      >
        <Table
          {...getTableProps()}
          variant={'simple'}
          overflowX={{ base: 'auto', xl: 'unset' }}
          style={{
            border: '2px solid #f7f7f7',
          }}
        >
          {/* <Card> */}
          <Thead className="thead" bg={'#f9f9f9'}>
            {headerGroups.map((headerGroup) => (
              <Tr
                {...headerGroup.getHeaderGroupProps()}
                borderBottom={'2px solid #f7f7f7'}
              >
                {headerGroup.headers.map((column) => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    color={'#191919'}
                    textAlign={'start'}
                    p={'10px 10px'}
                  >
                    {column.render('Header')}
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? ' 🔽'
                          : ' 🔼'
                        : ''}
                    </span>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>
          <Tbody {...getTableBodyProps()} fontSize={'17px'}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <Tr
                  {...row.getRowProps()}
                  borderBottom={'2px solid #f7f7f7'}
                  _hover={{ bg: '#FAF9F6' }}
                  cursor={'pointer'}
                >
                  {row.cells.map((cell) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        p={'12px'}
                        className="industryForAction"
                        textAlign={'start'}
                        justifyContent={'center'}
                      >
                        {cell.render('Cell')}
                      </Td>
                    );
                  })}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </Box>
      <Box
        p={'20px 5px'}
        display={{ base: 'block', xl: 'flex' }}
        justifyContent={'space-between'}
        alignItems={'center'}
      >
        <Box mb={5}>
          <Box mr={'10px'} color={'#000'}>
            <span style={{ color: '#20212396' }}>
              Page{' '}
              <span>
                {pageIndex + 1} of {Math.ceil(data.length / pageSize)}
              </span>{' '}
            </span>
          </Box>
        </Box>
        <Box display={{ base: 'flex', xl: 'flex' }}>
          <Box mr={'10px'} display={'flex'} alignItems={'center'}>
            <Button
              onClick={() => handlePageChange('previous')}
              disabled={!canPreviousPage}
              bg={'#f3f0f0'}
              mr={'5px'}
              h={'40px'}
              w={'40px'}
              borderRadius="50%"
              lineHeight="1em"
              flexShrink={0}
              fontWeight={800}
            >
              {'<'}
            </Button>{' '}
            {getPageNumbers().map((page, index) => (
              <Button
                key={index}
                mr={'5px'}
                h={'40px'}
                w={'40px'}
                borderRadius="100px"
                lineHeight="1em"
                flexShrink={0}
                fontWeight={800}
                background={pageIndex + 1 === page ? '#3311db' : 'unset'}
                color={pageIndex + 1 === page ? '#fff' : 'unset'}
                onClick={() =>
                  typeof page === 'number' ? handleGoPage(page - 1) : null
                }
              >
                {page}
              </Button>
            ))}
            <Button
              onClick={() => handlePageChange('next')}
              disabled={!canNextPage}
              bg={'#f3f0f0'}
              h={'40px'}
              w={'40px'}
              borderRadius="100px"
              lineHeight="1em"
              flexShrink={0}
              fontWeight={800}
            >
              {'>'}
            </Button>{' '}
          </Box>
          <Box></Box>
        </Box>
      </Box>
    </>
  );
};

export default CohortsTable;
